import { useTranslation } from "react-i18next";
import type { PropsWithChildren, Ref } from "react";
import { forwardRef } from "react";
import clsx from "clsx";
import { BounceLoader } from "react-spinners";

import { Icon } from "../atoms/icons";

import classes from "./styles.module.scss";

import type { IFormInputBoxProps, IFormInputIconProps } from ".";

import { Tooltip } from "@/components/atoms/tooltip";

export const FormInputBox = forwardRef(function FormControlBx(
  props: PropsWithChildren<IFormInputBoxProps>,
  ref: Ref<HTMLDivElement>,
) {
  const { disabled, readOnly, className, children, validation, ...rest } =
    props;

  return (
    <div
      ref={ref}
      className={clsx([classes.inputBox, className])}
      data-disabled={!!disabled}
      data-readonly={!!readOnly}
      data-validation={validation}
      {...rest}
    >
      {children}
    </div>
  );
});

export const FormInputIcon = forwardRef(function FormInputIcon(
  props: IFormInputIconProps,
  ref: Ref<HTMLSpanElement>,
) {
  const {
    iconName,
    type,
    className,
    isError,
    isLoading,
    disabled,
    readOnly,
    iconProps,
    ...rest
  } = props;

  const { t } = useTranslation("form");

  const getIcon = () => {
    if (isError)
      return (
        <Tooltip text={t("errorOcurred")}>
          <Icon name={"Danger"} color={"danger-main"} />
        </Tooltip>
      );
    if (isLoading)
      return <BounceLoader size={18} color={"#29A9E14D"} loading />;
    return <Icon name={iconName} {...iconProps} />;
  };

  return (
    <span
      className={clsx([
        classes.iconOutline,
        (disabled || readOnly) && "color-inherit",
      ])}
    >
      <span
        ref={ref}
        className={clsx([
          type === "bgIcon" || isError || isLoading || disabled || readOnly
            ? classes.bgIcon
            : classes.actionIcon,
          isError && "pointer-events-initial",
          className,
        ])}
        {...rest}
      >
        {getIcon()}
      </span>
    </span>
  );
});
